import { useMutation } from '@tanstack/react-query';
import { getCity } from '@/api/city';
import { CityData, GetDeleteCityData } from "@/types";
import { PostParam } from "@/types";

export function useGetCity(props?: PostParam) {
    const { onSuccess, onError } = props || {};

    return useMutation<CityData, Error, GetDeleteCityData>({
        mutationFn: getCity,
        onSuccess,
        onError
    });
}
